<template>
	<div class="category">
		<section class="slider-container">
			<h2 class="slider-heading">{{ title }}</h2>
			<div class="pl-5rm">
				<div v-if="category_data.length > 0">
					<carousel :margin="5" :loop="false" :navText="custnavText" :rewind="false" :responsive="{
						0: {
							items: 3,
							nav: true
						},
						600: {
							items: 3,
							nav: true
						},
						1000: {
							items: 7,
							nav: true,
						}
					}">
						<div class="item" v-for="(item, index) in category_data" :key="index">
							<div class="series-block" @click="goToPlayer(item)">
								<img class="img-fluid" :src="item.video.languages[0].thumbnailLink.small" alt="" />
								<div class="more-cnt text-center">
									<span @click="removeResumeList(item)" class="resume-close-btn">&times;</span>
									<h5 class="pt-3" style="margin-top: 0rem !important">
										{{ item.video.languages[0].title | trim }}
									</h5>
									<p class="py-2" v-if="item.video.metaData.running_time">
										Duration {{ item.video.metaData.running_time }}
									</p>
									<p class="py-3">{{ getDesc(item) }}</p>
									<div class="d-flex justify-content-between">
										<a class="border circle-Sm" @click="voteVideo(item, true)">
											<img class="like" src="../assets/img/like.svg" alt="" />
										</a>

										<a class="border circle-Sm" @click="voteVideo(item, false)">
											<img class="unlike" src="../assets/img/unlike.svg" alt="" />
										</a>

										<a class="border circle-Sm" @click="toggleFavorited(item)">
											<img src="../assets/img/minis-icon.svg" v-if="my_favourite(item)" alt=""
												class="plus-icon" />
											<img class="plus-icon" src="../assets/img/plus.svg" v-else />
										</a>
									</div>
									<div class="py-4 d-flex justify-content-center">
										<a>
											<img src="../assets/img/motion_photos_on-24px.svg" @click="playvideo(item)"
												style="width:50px" alt="" />
										</a>
									</div>

									<div class="pt-2 d-flex justify-content-center">
										<a @click="goToDetails(item)" class="d-inline-block btn btn-outline-light">
											More
											<i class="fa fa-angle-right ml-2" aria-hidden="true"></i>
										</a>
									</div>
								</div>
							</div>
						</div>
					</carousel>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import carousel from "vue-owl-carousel";
import Helpers from "../Mixins/Helpers.js";
export default {
	name: "category",
	components: {
		carousel,
	},
	props: ["title", "apiOptions"],
	mixins: [Helpers],
	filters: {
		trim: function (value) {
			if (value.length > 20) {
				return value.substring(0, 20) + "...";
			} else {
				return value;
			}
		},
	},
	data() {
		return {
			show_right: false,
			tryCon: false,
			custnavText: ["", ""],
		};
	},
	computed: {
		category_data() {
			return this.$store.state.user.resumelist;
		},
		// showFavGlobal() {
		// 	return this.$store.state.user.showMylist;
		// },
	},
	methods: {
		getDesc(item) {
			if (item.video.languages[0].title > 20) {
				if (item.video.metaData.title > 30) {
					return "";
				} else {
					return item.video.languages[0].description.substring(0, 20) + "...";
				}
			} else {
				return item.video.languages[0].description.substring(0, 30) + "...";
			}
		},
		voteVideo(show, status) {
			this.$store
				.dispatch("voteVideo", {
					id: show.video.id,
					status: status,
				})
				.then((res) => { });
		},
		my_favourite(show) {
			for (var i = 0; i < this.$store.state.user.mylist.length; i++) {
				var item = this.$store.state.user.mylist[i];
				if (item.id == show.video.id) return true;
			}
			return false;
		},
		toggleFavorited(show) {
			this.$store.commit("refreshMyList", false);
			if (this.my_favourite(show)) {
				this.$store
					.dispatch("updatemyList", {
						id: show.video.id,
						value: false,
						type: show.video.type,
					})
					.then(() => {
						this.$store.commit("refreshMyList", true);
					});
			} else {
				this.$store
					.dispatch("updatemyList", {
						id: show.video.id,
						value: true,
						type: show.video.type,
					})
					.then(() => {
						this.$store.commit("refreshMyList", true);
					});
			}
		},
		getparentId() {
			return this.apiOptions;
		},
		getHrefToDetails(movie, parent) {
			if (this.apiOptions == "mylist") {
				return "/details/" + movie + "/" + this.apiOptions;
			} else {
				return "/details/" + movie + "/" + this.apiOptions;
			}
		},
		goToPlayer(video) {
			if (this.isPlatformMobile() == true || this.isPlatformTablet() == true) {
				this.goToDetails(video);
			}
		},
		goToDetails(current) {
			var dynamicRoute = "";
			if (current.video.type == "vod") {
				dynamicRoute =
					"/details/" + current.video.id + "/" + this.parent;
			} else if (current.video.type == "Season") {
				dynamicRoute = "/playlistdetails/" + current.video.id;
			} else if (current.video.type == "Series") {
				dynamicRoute = "/detailseries/" + current.id;
			}

			this.$router.push("" + dynamicRoute);
		},
		playvideo(current) {
			if (current.resumeTime > 0) {
				var dynamicRoute = "/viewvideo/" + current.video.id + "?resume=true";
				this.$router.push("" + dynamicRoute);
			} else {
				var dynamicRoute = "/viewvideo/" + current.video.id;
				this.$router.push("" + dynamicRoute);
			}
		},
		scrollLeft(amount) {
			this.scroll = setInterval(
				() => (this.$refs.scroller.scrollLeft += amount),
				5
			);
		},
		clearScroll() {
			clearInterval(this.scroll);
		},
		removeResumeList(item) {
			var DataToSend = {};
			DataToSend["video_id"] = item.video.id;
			DataToSend["status"] = 0;
			DataToSend["resumeTime"] = item.resumeTime;

			this.$store.dispatch("setResumeVideo", DataToSend).then(() => {
				return this.$store.dispatch("getResumeVideo");
			});
		},
	},
	created() {
		this.$store.commit("showPopup", false);
		this.parent = this.apiOptions;
		if (this.apiOptions == "mylist") {
			this.tryCon = true;
		} else {
			this.$store.dispatch("getCatalougeById", this.apiOptions).then((res) => {
				this.category_data = res._embedded.items;
			});
		}
	},
	mounted() {
		this.tryCon = true;
	},
};
</script>

<style scoped>
.owl-nav .disabled {
	display: none;
}

.owl-next,
.owl-prev {
	cursor: pointer;
}

.owl-next::before {
	font-size: 26px !important;
	position: absolute;
	top: 22%;
	left: 32%;
}

.owl-prev::before {
	font-size: 26px !important;
	position: absolute;
	top: 22%;
	left: 32%;
}

.resume-close-btn {
	color: #fff;
	float: right;
	font-size: 20px;
}

.resume-close-btn:hover,
.resume-close-btn:focus {
	color: #fff !important;
	text-decoration: none;
	cursor: pointer;
	font-weight: bold;
}
</style>
